import { render, staticRenderFns } from "./wage.vue?vue&type=template&id=70b2af53&"
import script from "./wage.vue?vue&type=script&lang=js&"
export * from "./wage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports